import { render } from "./pos-notes.vue?vue&type=template&id=fe28b840"
import script from "./pos-notes.vue?vue&type=script&lang=js"
export * from "./pos-notes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__